import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { LEDGER_DETAIL, LEDGER_DETAIL_FILTER, LEDGER_DETAIL_SORT_CLEAR, LEDGER_DETAIL_SORT, } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
class LedgerDetailsActions extends OnePlatformCommonActions {
    getLedgerDetails(detail, type) {
        this.dispatch({
            type: LEDGER_DETAIL,
            payload: { detail },
            reducerName: type,
        });
    }
    setSortData(sortData, type) {
        this.dispatch({
            type: LEDGER_DETAIL_SORT,
            payload: { sortData },
            reducerName: type,
        });
    }
    setFilterData(filters, type) {
        this.dispatch({
            type: LEDGER_DETAIL_FILTER,
            payload: { filterData: filters },
            reducerName: type,
        });
    }
    clearSortData() {
        this.dispatch({
            type: LEDGER_DETAIL_SORT_CLEAR,
        });
    }
}
export default LedgerDetailsActions;
